import React, { FC, useState } from 'react';
import { Page } from 'src/components';
import Toolbar from './components/Toolbar';
import {
  Box,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { slices, useAppDispatch } from 'src/redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { ProductIn } from 'src/redux/slices/purchase-order/types';
import { useSnackBar } from 'src/hooks';
import { PaginationV2 } from 'src/types';
import { Pagination } from '@material-ui/lab';

const { actions: purchaseOrderActions } = slices.purchaseOrder;

const ProductInList: FC = () => {
  const dispatch = useAppDispatch();

  const [keyword, setKeyword] = useState<string>('');
  const [productInList, setProductInList] = useState<ProductIn[]>([]);
  const [meta, setMeta] = useState<PaginationV2>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const snackBar = useSnackBar();

  const onChangeKeyword = (event: any) => {
    setKeyword(event.target.value);
  };

  const getProductInList = async (page: number = 1) => {
    setIsLoading(true);
    const res = unwrapResult(
      await dispatch(
        purchaseOrderActions.getProductInListThunk({ po_no: keyword, page })
      )
    );

    if (res?.success) {
      const productInList = res?.originalData?.data;

      setProductInList(productInList || []);
      setMeta(res?.originalData?.meta || {});
      !productInList?.[0] &&
        snackBar.show({
          severity: 'error',
          message: 'No Results Found.'
        });
    } else {
      snackBar.show({
        useSound: true,
        severity: 'error',
        message: 'Failed to get product in list.'
      });
    }
    setIsLoading(false);
  };

  const onClickProductIn = (po_id?: number) => {
    if (!po_id) {
      console.error('Invalid po_id');
      return;
    }
    window.open(`/app/product-in/${po_id}`, '_blank');
  };

  return (
    <Page className="productInListPage" title="Product In List">
      <Box style={{ padding: '0 1em' }}>
        <Box style={{ margin: '2em 0 2em 0' }}>
          <Typography color="textPrimary" gutterBottom variant="h3">
            Product In
          </Typography>
          <Toolbar
            keyword={keyword}
            onChange={onChangeKeyword}
            onSearch={getProductInList}
          />
        </Box>
        <Box style={{ marginBottom: '1em' }}>
          {isLoading ? <LinearProgress /> : null}
          <Table>
            <TableHead>
              <TableRow style={{ border: '1px solid #AEB4BE' }}>
                <TableCell>Order Number</TableCell>
                <TableCell>Date Created</TableCell>
                <TableCell>Branch</TableCell>
                <TableCell>Supplier</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isLoading && productInList?.[0]
                ? productInList?.map((i, ind) => (
                    <TableRow key={ind} style={{ border: '1px solid #AEB4BE' }}>
                      <TableCell
                        onClick={() => onClickProductIn(i?.po_id)}
                        style={{ cursor: 'pointer' }}
                      >
                        {i?.po_no}
                      </TableCell>
                      <TableCell>{i?.po_date}</TableCell>
                      <TableCell>{i?.branch_name}</TableCell>
                      <TableCell>{i?.supplier}</TableCell>
                    </TableRow>
                  ))
                : null}
            </TableBody>
          </Table>
          {!isLoading ? (
            <div
              style={{ margin: '1em', display: 'flex', justifyContent: 'end' }}
            >
              <Pagination
                count={meta?.last_page || 1}
                page={meta?.current_page || 1}
                onChange={(_, p) => getProductInList(p)}
              />
            </div>
          ) : null}
        </Box>
      </Box>
    </Page>
  );
};

export default ProductInList;
